import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Pagination, Button, Spinner, Form } from "react-bootstrap";
import { RootState } from "../../store";
import { connect } from "react-redux";
import Layout from "../../containers/hocs/layout/Layout";
import Swal from "sweetalert2";
import { ArrowClockwise, Eraser, Search } from "react-bootstrap-icons";
import { anularAltasActions } from "../../redux/actions/Altas/AnularAltas/anularAltasActions";
import MenuAltas from "../Menus/MenuAltas";
import SkeletonLoader from "../Utils/SkeletonLoader";
import { Helmet } from "react-helmet-async";
import { Objeto } from "../Navegacion/Profile";
import { listaAltasRegistradasActions } from "../../redux/actions/Altas/AnularAltas/listaAltasRegistradasActions";
import { ListaEstadoFirmas } from "./EstadoFirmas/EstadoFirmas ";
import { ListaAltas } from "./RegistrarAltas";



interface FechasProps {
  fDesde: string;
  fHasta: string;
}
// export interface ListaAltasAnular {
//   aF_CLAVE: number,
//   ninv: string,
//   altaS_CORR: number,
//   serv: string,
//   dep: string,
//   esp: string,
//   ncuenta: string,
//   marca: string,
//   modelo: string,
//   serie: string,
//   estado: string,
//   precio: number,
//   fechA_ALTA: string,
//   nrecep: string
// }

interface DatosAltas {
  listaAltasRegistradas: ListaAltas[];
  listaAltasRegistradasActions: (fDesde: string, fHasta: string, af_codigo_generico: string, altasCorr: number, idocumento: number, establ_corr: number) => Promise<Array<ListaAltas> | null>;
  anularAltasActions: (activos: { aF_CLAVE: number }[]) => Promise<boolean>;
  token: string | null;
  isDarkMode: boolean;
  objeto: Objeto;
  nPaginacion: number; //número de paginas establecido desde preferencias
  listaEstadoFirmas: ListaEstadoFirmas[];
}

const AnularAltas: React.FC<DatosAltas> = ({ listaAltasRegistradasActions, anularAltasActions, listaAltasRegistradas, listaEstadoFirmas, token, objeto, isDarkMode, nPaginacion, }) => {
  const [error, setError] = useState<Partial<FechasProps> & {}>({});
  const [loading, setLoading] = useState(false); // Estado para controlar la carga
  const [loadingRefresh, setLoadingRefresh] = useState(false);
  // const [elementoSeleccionado, setElementoSeleccionado] = useState<ListaAltas[]>([]);
  const [loadingAnular, setLoadingAnular] = useState(false);
  const [filasSeleccionadas, setFilasSeleccionadas] = useState<string[]>([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const elementosPorPagina = nPaginacion;

  const [Inventario, setInventario] = useState({
    fDesde: "",
    fHasta: "",
    altaS_CORR: 0,
    af_codigo_generico: ""
  });

  const listaAuto = async () => {
    if (token) {
      if (listaAltasRegistradas.length === 0) {
        setLoading(true);
        const resultado = await listaAltasRegistradasActions("", "", "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
        if (!resultado) {
          Swal.fire({
            icon: "warning",
            title: "Sin Resultados",
            text: "No hay registros disponibles para mostrar.",
            background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
            color: `${isDarkMode ? "#ffffff" : "000000"}`,
            confirmButtonColor: `${isDarkMode ? "#007bff" : "444"}`,
            customClass: {
              popup: "custom-border", // Clase personalizada para el borde
            }
          });
          setLoading(false);
        }
        else {
          setLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    listaAuto();
  }, [listaAltasRegistradasActions, token, listaAltasRegistradas.length, setLoading]); // Asegúrate de incluir dependencias relevantes

  const validate = () => {
    let tempErrors: Partial<any> & {} = {};
    if (Inventario.fDesde > Inventario.fHasta) tempErrors.fDesde = "La fecha de inicio es mayor a la fecha de término";

    setError(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    // Validación específica para af_codigo_generico: solo permitir números
    if (name === "af_codigo_generico" && !/^[0-9]*$/.test(value)) {
      return; // Salir si contiene caracteres no numéricos
    }

    // Convertir a número solo si el campo está en la lista
    const camposNumericos = ["altaS_CORR"];
    const newValue: string | number = camposNumericos.includes(name)
      ? parseFloat(value) || 0
      : value;

    // Actualizar estado
    setInventario((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };

  const handleBuscar = async (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLElement>) => {
    e.preventDefault();
    setLoading(true);

    let resultado: Array<ListaAltas> | null = [];
    // Si ambas fechas están ingresadas, validar    
    if (!validate()) {
      setLoading(false);
      return;
    }

    resultado = await listaAltasRegistradasActions(Inventario.fDesde, Inventario.fHasta, Inventario.af_codigo_generico, Inventario.altaS_CORR, 0, objeto.Roles[0].codigoEstablecimiento);

    if (!resultado) {
      Swal.fire({
        icon: "warning",
        title: "Sin Resultados",
        text: "No se encontraron resultados para la consulta realizada.",
        confirmButtonText: "Ok",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#007bff" : "444"}`,
        customClass: {
          popup: "custom-border", // Clase personalizada para el borde
        }
      });
      resultado = await listaAltasRegistradasActions("", "", "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
      setLoading(false); //Finaliza estado de carga
      return;
    } else {
      paginar(1);
      setLoading(false); //Finaliza estado de carga
    }

  };

  const handleRefrescar = async () => {
    setLoadingRefresh(true); //Finaliza estado de carga
    const resultado = await listaAltasRegistradasActions("", "", "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
    if (!resultado) {
      setLoadingRefresh(false);
    } else {
      paginar(1);
      setLoadingRefresh(false);
    }
  };

  const handleLimpiar = () => {
    setInventario((prevInventario) => ({
      ...prevInventario,
      fDesde: "",
      fHasta: "",
      altaS_CORR: 0,
      af_codigo_generico: ""

    }));
  };

  const setSeleccionaFilas = (index: number) => {
    setFilasSeleccionadas((prev) =>
      prev.includes(index.toString())
        ? prev.filter((rowIndex) => rowIndex !== index.toString())
        : [...prev, index.toString()]
    );
    // console.log("indices seleccionmados", index);
  };

  const handleSeleccionaTodos = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setFilasSeleccionadas(
        elementosActuales.map((_, index) =>
          (indicePrimerElemento + index).toString()
        )
      );
      // console.log("filas Seleccionadas ", filasSeleccionadas);
    } else {
      setFilasSeleccionadas([]);
    }
  };

  const handleAnularSeleccionados = async () => {
    const selectedIndices = filasSeleccionadas.map(Number);
    const activosSeleccionados = selectedIndices.map((index) => {
      return {
        aF_CLAVE: listaAltasRegistradas[index].aF_CLAVE,
        USUARIO_MOD: objeto.IdCredencial,
        ESTABL_CORR: objeto.Roles[0].codigoEstablecimiento,
      };

    });
    const result = await Swal.fire({
      icon: "info",
      title: "Anular Altas",
      text: `Confirme para anular las altas seleccionadas`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Confirmar y Anular",
      background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
      color: `${isDarkMode ? "#ffffff" : "000000"}`,
      confirmButtonColor: `${isDarkMode ? "#007bff" : "444"}`,
      customClass: {
        popup: "custom-border", // Clase personalizada para el borde
      }
    });

    // selectedIndices.map(async (index) => {

    if (result.isConfirmed) {
      setLoadingAnular(true);
      // const elemento = listaAltas[index].aF_CLAVE;
      // console.log("despues del confirm elemento", elemento);

      // const clavesSeleccionadas: number[] = selectedIndices.map((index) => listaAltas[index].aF_CLAVE);      
      // console.log("Claves seleccionadas para registrar:", clavesSeleccionadas);
      // Crear un array de objetos con aF_CLAVE y nombre


      // console.log("Activos seleccionados para registrar:", activosSeleccionados);

      const resultado = await anularAltasActions(activosSeleccionados);
      if (resultado) {
        document.body.style.overflow = "hidden"; // Evita que el fondo se desplace
        Swal.fire({
          icon: "success",
          title: "Altas anuladas",
          text: `Se han anulado correctamente las altas seleccionadas`,
          background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
          color: `${isDarkMode ? "#ffffff" : "000000"}`,
          confirmButtonColor: `${isDarkMode ? "#007bff" : "444"}`,
          customClass: {
            popup: "custom-border", // Clase personalizada para el borde
          }
        });

        setLoadingAnular(false);
        listaAltasRegistradasActions("", "", "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
        setFilasSeleccionadas([]);
      } else {
        Swal.fire({
          icon: "error",
          title: ":'(",
          text: `Hubo un problema al anular las Altas.`,
          background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
          color: `${isDarkMode ? "#ffffff" : "000000"}`,
          confirmButtonColor: `${isDarkMode ? "#007bff" : "444"}`,
          customClass: {
            popup: "custom-border", // Clase personalizada para el borde
          }
        });
        setLoadingAnular(false);
      }

    }
    // })
  };
  // Lógica de Paginación actualizada
  const indiceUltimoElemento = paginaActual * elementosPorPagina;
  const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina;
  const elementosActuales = useMemo(
    () =>
      listaAltasRegistradas.slice(indicePrimerElemento, indiceUltimoElemento),
    [listaAltasRegistradas, indicePrimerElemento, indiceUltimoElemento]
  );
  // const totalPaginas = Math.ceil(datosInventarioCompleto.length / elementosPorPagina);
  const totalPaginas = Array.isArray(listaAltasRegistradas)
    ? Math.ceil(listaAltasRegistradas.length / elementosPorPagina)
    : 0;
  const paginar = (numeroPagina: number) => setPaginaActual(numeroPagina);

  return (
    <Layout>
      <Helmet>
        <title>Anular Altas</title>
      </Helmet>
      <MenuAltas />
      <form>
        <div className={`border border-botom p-2 rounded ${isDarkMode ? "darkModePrincipal text-light border-secondary" : ""}`}>
          <h3 className="form-title fw-semibold border-bottom p-1">Anular Altas</h3>
          <Row className="border rounded p-2 m-2">
            <Col md={3}>
              <div className="mb-2">
                <div className="flex-grow-1 mb-2">
                  <label htmlFor="fDesde" className="form-label fw-semibold small">Desde</label>
                  <div className="input-group">
                    <input
                      aria-label="Fecha Desde"
                      type="date"
                      className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""} ${error.fDesde ? "is-invalid" : ""}`}
                      name="fDesde"
                      onChange={handleChange}
                      value={Inventario.fDesde}
                      max={new Date().toLocaleDateString("sv-SE", { timeZone: "America/Santiago" })}
                    />
                  </div>
                  {error.fDesde && <div className="invalid-feedback d-block">{error.fDesde}</div>}
                </div>

                <div className="flex-grow-1">
                  <label htmlFor="fHasta" className="form-label fw-semibold small">Hasta</label>
                  <div className="input-group">
                    <input
                      aria-label="Fecha Hasta"
                      type="date"
                      className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""} ${error.fHasta ? "is-invalid" : ""}`}
                      name="fHasta"
                      onChange={handleChange}
                      value={Inventario.fHasta}
                      max={new Date().toLocaleDateString("sv-SE", { timeZone: "America/Santiago" })}
                    />
                  </div>
                  {error.fHasta && <div className="invalid-feedback d-block">{error.fHasta}</div>}

                </div>
                <small className="fw-semibold">Filtre los resultados por fecha de alta.</small>
              </div>
            </Col>

            <Col md={2}>
              <div className="mb-2">
                <div className="mb-2">
                  <label htmlFor="af_codigo_generico" className="form-label fw-semibold small">Nº Inventario</label>
                  <input
                    aria-label="af_codigo_generico"
                    type="text"
                    className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                    name="af_codigo_generico"
                    placeholder="Ej: 1000000008"
                    onChange={handleChange}
                    value={Inventario.af_codigo_generico}
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="altaS_CORR" className="form-label fw-semibold small">Nº Alta</label>
                  <input
                    aria-label="altaS_CORR"
                    type="text"
                    className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                    name="altaS_CORR"
                    placeholder="Ej: 0"
                    onChange={handleChange}
                    value={Inventario.altaS_CORR}
                  />
                </div>
              </div>
            </Col>

            <Col md={3}>
              <div className="d-md-flex justify-content-md-start alig-items-center mt-4">
                <Button
                  onClick={handleBuscar}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleBuscar(e);
                    }
                  }}
                  variant={isDarkMode ? "secondary" : "primary"}
                  className="mx-1 mb-1 w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      {" Buscar"}
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="ms-1"
                      />
                    </>
                  ) : (
                    <>
                      {" Buscar"}
                      <Search className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                    </>
                  )}
                </Button>
                <Button
                  onClick={handleRefrescar}
                  variant={isDarkMode ? "secondary" : "primary"}
                  className="mx-1 mb-1 w-100 "
                >
                  {loadingRefresh ? (
                    <>
                      {" Refrescar "}
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="ms-1"
                      />
                    </>
                  ) : (
                    <>
                      {" Refrescar "}
                      <ArrowClockwise className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                    </>
                  )}
                </Button>
                <Button
                  onClick={handleLimpiar}
                  variant={isDarkMode ? "secondary" : "primary"}
                  className="mx-1 mb-1 w-100"
                >
                  Limpiar
                  <Eraser className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                </Button>
              </div>
            </Col>
          </Row>
          {/* Boton anular filas seleccionadas */}
          <div className="d-flex justify-content-end">
            {filasSeleccionadas.length > 0 ? (
              <Button
                variant="danger"
                onClick={handleAnularSeleccionados}
                className="m-1 p-2 d-flex align-items-center"  // Alinea el spinner y el texto
                disabled={loadingAnular}  // Desactiva el botón mientras carga
              >
                {loadingAnular ? (
                  <>
                    {" Anulando... "}
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"  // Espaciado entre el spinner y el texto
                    />

                  </>
                ) : (
                  <>
                    Anular
                    <span className="badge bg-light text-dark mx-1">
                      {filasSeleccionadas.length}
                    </span>
                    {filasSeleccionadas.length === 1 ? "Alta" : "Altas"}
                  </>
                )}
              </Button>
            ) : (
              <strong className="alert alert-dark border m-1 p-2 mx-2">
                No hay filas seleccionadas
              </strong>
            )}
          </div>

          {/* Tabla*/}
          {loading || loadingRefresh ? (
            <>
              {/* <SkeletonLoader rowCount={elementosPorPagina} /> */}
              <SkeletonLoader rowCount={10} columnCount={10} />
            </>
          ) : (
            <>
              {listaAltasRegistradas.length > 0 ? (
                <>
                  <div className='table-responsive'>
                    <table className={`table  ${isDarkMode ? "table-dark" : "table-hover table-striped "}`} >
                      <thead className={`sticky-top z-0 ${isDarkMode ? "table-dark" : "text-dark table-light "}`}>
                        <tr>
                          <th style={{
                            position: 'sticky',
                            left: 0
                          }}>
                            <Form.Check
                              className="check-danger"
                              type="checkbox"
                              onChange={handleSeleccionaTodos}
                              checked={filasSeleccionadas.length === elementosActuales.length && elementosActuales.length > 0}
                            />
                          </th>
                          <th scope="col" className="text-nowrap text-center">N° Inventario</th>
                          <th scope="col" className="text-nowrap text-center">N° Alta</th>
                          <th scope="col" className="text-nowrap text-center">Fecha Alta</th>
                          <th scope="col" className="text-nowrap text-center">Servicio</th>
                          <th scope="col" className="text-nowrap text-center">Dependencia</th>
                          <th scope="col" className="text-nowrap text-center">Especie</th>
                          <th scope="col" className="text-nowrap text-center">N° Cuenta</th>
                          <th scope="col" className="text-nowrap text-center">Marca</th>
                          <th scope="col" className="text-nowrap text-center">Modelo</th>
                          <th scope="col" className="text-nowrap text-center">Serie</th>
                          <th scope="col" className="text-nowrap text-center">Estado</th>
                          <th scope="col" className="text-nowrap text-center">Precio</th>
                          <th scope="col" className="text-nowrap text-center">N° Recepcion</th>
                          {/* <th>Acción</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {elementosActuales.map((Lista, index) => {
                          const indexReal = indicePrimerElemento + index; // Índice real basado en la página
                          const esEstado0 = listaEstadoFirmas.some((f) => f.altaS_CORR === Lista.altaS_CORR && f.estado === 0);
                          const esEstado1 = listaEstadoFirmas.some((f) => f.altaS_CORR === Lista.altaS_CORR && f.estado === 1);
                          return (
                            <tr key={index} className={esEstado0 ? "table-warning" :
                              esEstado1 ? "table-success" : ""}>
                              <td style={{ position: 'sticky', left: 0 }}>
                                <Form.Check
                                  type="checkbox"
                                  onChange={() => setSeleccionaFilas(indexReal)}
                                  checked={filasSeleccionadas.includes(indexReal.toString())}
                                />
                              </td>
                              <td className="text-nowrap">{Lista.aF_CODIGO_GENERICO}</td>
                              <td className="text-nowrap">{Lista.altaS_CORR}</td>
                              <td className="text-nowrap">{Lista.fechA_ALTA}</td>
                              <td className="text-nowrap">{Lista.serv}</td>
                              <td className="text-nowrap">{Lista.dep}</td>
                              <td className="text-nowrap">{Lista.esP_NOMBRE}</td>
                              <td className="text-nowrap">{Lista.ctA_COD}</td>
                              <td className="text-nowrap">{Lista.deT_MARCA}</td>
                              <td className="text-nowrap">{Lista.deT_MODELO}</td>
                              <td className="text-nowrap">{Lista.deT_SERIE}</td>
                              <td className="text-nowrap">{Lista.estado}</td>
                              <td className="text-nowrap">
                                ${(Lista.deT_PRECIO ?? 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                              </td>
                              <td className="text-nowrap">{Lista.nrecep == "" || parseInt(Lista.nrecep) == 0 ? "Sin Nº Recepción" : Lista.nrecep}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {/* Paginador */}
                  <div className="paginador-container position-relative z-0">
                    <Pagination className="paginador-scroll">
                      <Pagination.First
                        onClick={() => paginar(1)}
                        disabled={paginaActual === 1}
                      />
                      <Pagination.Prev
                        onClick={() => paginar(paginaActual - 1)}
                        disabled={paginaActual === 1}
                      />

                      {Array.from({ length: totalPaginas }, (_, i) => (
                        <Pagination.Item
                          key={i + 1}
                          active={i + 1 === paginaActual}
                          onClick={() => paginar(i + 1)}
                        >
                          {i + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => paginar(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                      />
                      <Pagination.Last
                        onClick={() => paginar(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                      />
                    </Pagination>
                  </div>
                </>
              ) : (
                <div style={{ height: "50vh", overflowY: "auto" }} className="mt-2">
                  <p className={`text-center  pt-1 pb-1 mb-1 rounded border-0 fs-09em fw-semibold ${isDarkMode ? 'bg-dark text-light border border-secondary' : 'bg-light text-muted border'}`}>
                    No hay resultados para mostrar.
                  </p>
                </div>
              )}
            </>
          )}

        </div>
      </form>
    </Layout >
  );
};

const mapStateToProps = (state: RootState) => ({
  listaAltasRegistradas: state.listaAltasRegistradasReducers.listaAltasRegistradas,
  listaEstadoFirmas: state.listaEstadoFirmasReducers.listaEstadoFirmas,
  token: state.loginReducer.token,
  objeto: state.validaApiLoginReducers,
  isDarkMode: state.darkModeReducer.isDarkMode,
  nPaginacion: state.mostrarNPaginacionReducer.nPaginacion
});

export default connect(mapStateToProps, {
  listaAltasRegistradasActions,
  anularAltasActions
})(AnularAltas);
